import React from 'react';
import GruShell from '../../components/gru/GruShell';
import TabellaInterventi from './components/TabellaInterventi';

// /gru-interventi — sostituzioni, rientri e ordini
const GruInterventiPage = () => (
  <GruShell indietroA="/gru-inventory">
    <TabellaInterventi />
  </GruShell>
);

export default GruInterventiPage;
